module.exports = __webpack_public_path__ + "static/media/close-icon-error.4011593f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RequestStatus/img/close-icon-error.svg
// module id = 485
// module chunks = 0